import React, { Component } from 'react'
import { CustomInput, Label, Input, FormGroup, FormFeedback, Form } from 'reactstrap';
import EirButton from '../eir-button/EirButton';
import EirRecaptcha from '../eir-recaptcha/EirRecaptcha';

export class EirOnlineRefundRequestForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sending: false,
            countyList: [],
            response: null,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillMount = () => {
        fetch('/json/counties.txt')
            .then(res => res.json())
            .then(data => this.setState({ countyList: data }))
    }

    renderContent = (content) => {

        return { __html: content };

    }
    emailScript = (e) => {
        var email_val = $("#Customers_Email_Address").val();
        $("#EMAIL_FROM_ADDRESS_OVERRIDE").val(email_val);
    }
    
    async handleSubmit(event) {
        let form = event.target;
        event.preventDefault();
        event.stopPropagation();
        form = $("form")[0];
        if (form.checkValidity() != false) {
            this.setState({
                sending: true
            });

            let response = await fetch(this.props.action,
                {
                    method: form.method,
                    body: new FormData($("form")[0])
                }
            );

            this.setState({
                response: (response.ok ? await response.json() : false),
                sending: false
            });
            if ((this.state.response != null && this.state.response.result.status == 'success') || (this.state.response != null && (this.state.response.result.status == 'failure' || this.state.response == false))) {
                let scrollStep = -window.pageYOffset / (1000 / 15);
                let scrollInterval = setInterval(function () {
                    if (window.pageYOffset != 0) {
                        window.scrollBy(0, scrollStep);

                    } else clearInterval(scrollInterval);
                }, 15);
            }
        }
        form.classList.add('was-validated');

        if ($(".was-validated .form-control:invalid")[0] != undefined) {
            $(".was-validated .form-control:invalid")[0].focus();
        }
    }
    render() {

        const CList = this.state.countyList.counties;

        return (
            <div className="bereavement-forms">
                <div className="mb-5 mt-5 container d-flex flex-column align-items-center justify-content-center">
                    <h2>Refund Request Form</h2>
                    <p>The below form will allow a customer to request a refund in an easy and timely manner.</p>
                    <p>Please note that we will make every attempt to close this refund by electronic fund transfer back to the bank account linked to your eir account. Should you not have bank details on your eir account we will issue this refund in the form of a cheque.</p>
                    <p>Upon completion of this request we will notify you by email.</p>
                    <p>For further information click here to see our <a aria-label="Frequently asked questions" target="_blank" href="https://eir.ie/support/billing/billing-refund/">Frequently asked questions.</a> </p>
                    

                </div>
                {(this.state.response == null && !this.state.sending) && (

                    <Form method="post" action={this.props.action} noValidate={false} className="needs-validation d-flex flex-column align-items-center justify-content-center" id="bereavement-form" onSubmit={this.handleSubmit} >
                        <Input type="hidden" value={this.props.email} id="Email_To_Address" name="Email_To_Address" />
                        <Input type="hidden" value="Refund Request Form" id="Email_Subject" name="Email_Subject" />
                        <Input type="hidden" value={this.props.formName} id="Form_Name" name="Form_Name" />
                        <Input type="hidden"  id="EMAIL_FROM_ADDRESS_OVERRIDE" name="EMAIL_FROM_ADDRESS_OVERRIDE" />

                        {/* Customer Identity */}
                        <Input type="hidden" value="Customer Details:" id="Customer_Sub_Heading" name="Customer_Sub_Heading" />
                        <div className="customer-identity-container">
                            <h4>
                                Customer Details:
                            </h4>
                            <FormGroup>
                                <Label>Customer's First Name<span className="mandatory">*</span></Label>
                                <Input name="Customers_First_Name" pattern="[a-zA-Z'’\s]+" type="text" id="Customers_First_Name" required />
                                <FormFeedback>Please enter first name</FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>Customer's Surname<span className="mandatory">*</span></Label>
                                <Input name="Customers_Surname" pattern="[a-zA-Z'’\s]+" type="text" id="Customers_Surname" required />
                                <FormFeedback>Please enter a name</FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>Account Number<span className="mandatory">*</span></Label>
                                <Input type="text" name="Customers_Account_Number" id="Customers_Account_Number" required />
                                <FormFeedback>Please enter a valid account number</FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>Email address<span className="mandatory">*</span></Label>
                                <Input type="email" name="Customers_Email_Address" id="Customers_Email_Address" onChange={this.emailScript} required />
                                <FormFeedback>Please enter a valid email address</FormFeedback>
                            </FormGroup>

                            <FormGroup>
                                <Label>Mobile Number</Label>
                                <Input type="tel" minLength="6" maxLength="10" pattern="^[0-9-+s()]*$" name="Customers_Mobile_No" id="Customers_Mobile_No" />

                            </FormGroup>

                            <FormGroup>
                                <Label>Customer's address line 1<span className="mandatory">*</span></Label>
                                <Input name="Customers_Address_One" type="text" id="Customers_Address_One" required />
                                <FormFeedback>Please enter address line 1 </FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>Customer's address line 2</Label>
                                <Input name="Customers_Address_Two" type="text" id="Customers_Address_Two" />
                            </FormGroup>
                            <FormGroup>
                                <Label>Town/City<span className="mandatory">*</span></Label>
                                <Input name="Customers_Town_City" type="text" id="Customers_Town_City" required />
                                <FormFeedback>Please enter Town/City</FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>County<span className="mandatory">*</span></Label>
                                <Input type="select" name="Customers_County" id="Customers_County" required>
                                    <option value="">Select County</option>
                                    {CList != undefined &&
                                        (CList.map((name, i) => <option key={name.name}>{name.name}</option>))
                                    }
                                </Input>
                                <FormFeedback>Please enter county </FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>Eircode<span className="mandatory">*</span></Label>
                                <Input name="Customers_Eircode" type="text" id="Customers_Eircode" minLength="7" maxLength="8" pattern="^[0-9a-zA-Z\s]*$" required />
                                <FormFeedback>Please enter Eircode </FormFeedback>
                            </FormGroup>

                            {/* Refund Details */}

                            <div>
                                <h4>
                                    Refund Details:
                            </h4>
                                <Input type="hidden" value="Refund Details:" id="Close_Sub_Heading" name="Close_Sub_Heading" />

                                <FormGroup>
                                    <Label>Please enter the value of the refund <span className="mandatory">*</span></Label>
                                    <div className="amount_prefix">
                                        <Input name="Value_Of_Refund" pattern="^[0-9-+s()]*$" style={{ paddingLeft: 25 }} type="text" id="Value_Of_Refund" required />
                                    </div>
                                    <FormFeedback>Please enter value of refund</FormFeedback>
                                </FormGroup>

                                <FormGroup>
                                    <Label>Please enter the reason for this refund<span className="mandatory">*</span></Label>

                                    <Input name="Reason_For_Refund" type="select" id="Reason_For_Refund" required>
                                        <option value="">Select the reason for refund</option>
                                        <option value="Final Bill Credit - credit appearing on the final bill of a closed account">Final Bill Credit - credit appearing on the final bill of a closed account</option>
                                        <option value="Overpayment - Where an amount has been overpaid in error">Overpayment - Where an amount has been overpaid in error</option>
                                        <option value="Double payment - Where there has been a double payment made in error">Double payment - Where there has been a double payment made in error</option>
                                        <option value="Deposit Refund - Where customers who have paid a mobile deposit wish to request this back after the 7th bill ">Deposit Refund - Where customers who have paid a mobile deposit wish to request this back after the 7th bill </option>

                                    </Input>
                                    <FormFeedback>Please enter the reason for this refund</FormFeedback>
                                </FormGroup>


                            </div>



                            <div>
                                {/* Confirmation Details */}

                                <FormGroup >
                                    <div >
                                        <div className="form-group">
                                            <div>
                                                <div className="custom-checkbox custom-control">
                                                    <Input required name="Primary_Refund_Accepted" type="checkbox" id="Primary_Refund_Accepted" className="custom-control-input" value="true" />
                                                    <label className="custom-control-label" htmlFor="Primary_Refund_Accepted">I understand the primary refund method will be by electronic fund transfer back to my bank and that this<br />can take up to 10 working days.</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </FormGroup>
                                <FormGroup >
                                    <div >
                                        <div className="form-group">
                                            <div>
                                                <div className="custom-checkbox custom-control">
                                                    <Input required name="Bank_Refund_Accepted" type="checkbox" id="Bank_Refund_Accepted" className="custom-control-input" value="true" />
                                                    <label className="custom-control-label" htmlFor="Bank_Refund_Accepted">I understand that should there be no bank payment details on my account, that this refund will be issued by <br />cheque in the name of the account holder and that this refund can take up to 14 working days to issue.</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </FormGroup>
                                <FormGroup >
                                    <div >
                                        <div className="form-group">
                                            <div>
                                                <div className="custom-checkbox custom-control">
                                                    <Input required name="Eir_Contact_Accepted" type="checkbox" id="Eir_Contact_Accepted" className="custom-control-input" value="true" />
                                                    <label className="custom-control-label" htmlFor="Eir_Contact_Accepted">I understand that I may be contacted by eir to confirm any further information that may be required to process<br />my refund.<b>Please note eir will never ask for your bank details by email.</b> </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </FormGroup>
                                {/* Form Confirmation */}
                                <p className="justify-content">The personal data logged on this form will be processed in accordance with eir’s privacy policy. The use of which is to allow the request to process a refund request. The data will not be used for any other purpose. By clicking submit you confirm that you have read and understood this policy.</p>
                            </div>

                        </div>




                        <div className="d-flex justify-content-start">
                            <EirRecaptcha />
                        </div>

                        <div className="mt-4 d-flex justify-content-center">
                            <button aria-label="Submit form" type="submit" name="Submit" value="Submit" className="btn btn-primary" 
                                onClick={this.handleSubmit}>Submit</button>

                        </div>
                    </Form>
                )
                }

                {(this.state.response != null && this.state.response.result.status == 'success') && (
                    <div className="form-success align-items-center" dangerouslySetInnerHTML={this.renderContent(this.props.successMsg)}></div>
                )}

                {(this.state.response != null && (this.state.response.result.status == 'failure' || this.state.response == false)) && (
                    <div className="form-error align-items-center">Form Submitted Failed</div>
                )}
            </div>
        )
    }
}

export default EirOnlineRefundRequestForm;
